// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Ar3V","type":"styles_type__22U0y","choices":"styles_choices__HQMSy"};